﻿export interface IEmailFlagValue {
    flag: number,
    value: number
}
